import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "op-icon",
  "use": "op-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"op-icon\"><path fill=\"currentColor\" d=\"M8 1a6 6 0 1 0 0 12A6 6 0 0 0 8 1m0 11a5 5 0 1 1 .001-10.001A5 5 0 0 1 8 12m0-6.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-.5 1v4h1v-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol